export default "__VITE_ASSET__af3770ad__"